import { useEffect, useState } from 'react';
import { fetchPlanTiersForSites } from '../services/pluginPlanService';

export function useSitePlanTiers(sites, freeSlug, proSlug) {
	const [planBySiteId, setPlanBySiteId] = useState({});

	useEffect(() => {
		if (!sites?.length || !freeSlug) {
			setPlanBySiteId({});
			return undefined;
		}

		let cancelled = false;

		fetchPlanTiersForSites(sites, freeSlug, proSlug).then((map) => {
			if (!cancelled) {
				setPlanBySiteId(map);
			}
		});

		return () => {
			cancelled = true;
		};
	}, [sites, freeSlug, proSlug]);

	return planBySiteId;
}
